import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductService } from '../../../../product/product.service';
import { Product } from '../../../models/product.model';
import { MessageService } from '../../../services/message.service';

@Component({
  standalone: false,
  selector: 'app-product-autocomplete',
  templateUrl: './product-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})

export class ProductAutocompleteComponent {
  @Input() productClass: string;
  @Input() searchTerm: string;
  @Input() selectedProductId: string;
  @Input() placeholder: string;
  @Input() areMaterialsIncluded: boolean;
  @Input() excludeFinishedProducts: boolean;
  products: Array<Product> = [];
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private message: MessageService,
              private productService: ProductService) {}

  
  getProducts(): void {
    this.productService.getListOfProducts({search: this.searchTerm, onlySearchIncluded: true, areMaterialsIncluded: this.areMaterialsIncluded}).subscribe(
      res => {
        const productClass = this.productClass === 'Proizvod' ? 'finishedProduct' : 'semiProduct';
        this.products = this.productClass ? res.results.filter(product => product.productClass === productClass) : res.results;

        if (this.excludeFinishedProducts) {
          this.products = res.results.filter(product => product.productClass === 'semiProduct');
        }

        this.isListVisible = this.products.length > 0 && this.searchTerm.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  isSelectedProduct(product: Product): boolean {
    return product.productId === this.selectedProductId;
  }

  onSelect(product: Product): void {
    this.selected.emit(product);
    this.isListVisible = false;
  }
}